"use client";
import {
  useMemo,
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { useSortBy, useHits } from "@dxp-feed/algolia";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import MobileSortable from "./_components/MobileSortable";
import ArticleCard from "./_components/ArticleCard";
import { useEffect, useState } from "react";
import { ArticleType } from "@/utils/types/article";
import {
  SHORTING_ARTICLE,
  ARTICLES_FILTER,
  GLOBAL_SEARCH_RESULTS_SECTIONS,
  DEFAULT_ARTICLE_NUMBER,
  DEFAULT_ARTICLE_FILTER,
} from "@/utils/constant";
import { setPagecount } from "@/utils/redux/common/pagination";
import SideBarTemplate from "../algolia/SideBarTemplate";
import { useAlgoliaViewAnalyticsEvent } from "@/utils/hooks/useAlgoliaViewAnalyticsEvent";
import ArticleCategoryList from "./_components/ArticleCategory";
import { fetchAemArticleData } from "@/utils/redux/article/aemContent";
import { getItems } from "@/helpers/useCommonFunctions";
import { AddFULLAEMURL } from "./CommonFunctions";
import { RenderHTML } from "@/helpers/ServerFuncytions";
import { useTrendingItems } from "@/utils/hooks/useTrendingItems";

interface ArticleListingProps {
  text?: string;
  searchQuery: string;
  isSearchPage?: boolean;
  description?: string;
  preferredResults?: ArticleType[];
}

const ArticleListing = ({
  searchQuery,
  isSearchPage = false,
  preferredResults,
}: ArticleListingProps) => {
  const { items: hitsItems } = useHits() as { items: ArticleType[] };

  const { data: popularItems } = useTrendingItems(hitsItems.length === 0);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [items, setItems] = useState(
    getItems(searchQuery, isSearchPage, hitsItems, popularItems?.articles?.hits)
  );
  const dispatch = useAppDispatch();
  const [isUlVisible, setIsUlVisible] = useState(false);
  const [isSortVisible, setIsSortVisible] = useState(false);
  const [isCatVisible, setIsCatVisible] = useState(false);
  const gridRef = useAlgoliaViewAnalyticsEvent(
    items,
    GLOBAL_SEARCH_RESULTS_SECTIONS.ARTICLE
  );
  const { banner, data } = useAppSelector((state) => state.AemArticledataSlice);

  const breadcrumb = [
    { text: "Home", href: "/" },
    { text: "Articles", href: "" },
  ];

  const { options, currentRefinement } = useSortBy({
    items: SHORTING_ARTICLE,
  });
  /** Setting Sort Label */
  const heading: string = useMemo(() => {
    return options.find((option) => option.value === currentRefinement)
      ?.label as string;
  }, [options, currentRefinement]);

  const toggleCategory = () => setIsCatVisible((prev) => !prev);
  const toggleSort = () => setIsSortVisible((prev) => !prev);

  useEffect(() => {
    dispatch(setPagecount(DEFAULT_ARTICLE_NUMBER));
    dispatch(fetchAemArticleData());
  }, [dispatch, fetchAemArticleData]);

  useEffect(() => {
    setItems(
      getItems(
        searchQuery,
        isSearchPage,
        hitsItems,
        popularItems?.articles?.hits
      )
    );
  }, [isSearchPage, searchQuery, hitsItems, popularItems]);
  const onCategoryChange = (category:any) => {
    const selctedvalue = category?.value ? category?.value : null;
    setSelectedCategory(selctedvalue);
  };
  return (
    <SideBarTemplate
      breadcrumbList={breadcrumb}
      isUlVisible={isUlVisible}
      isCatVisible={isCatVisible}
      closeCat={() => setIsCatVisible(false)}
      closeUl={() => setIsCatVisible(false)}
      filterData={ARTICLES_FILTER}
      isSortVisible={isSortVisible}
      closeSort={toggleSort}
      isSearchPage={isSearchPage}
      type="articles"
      searchQuery={searchQuery}
      className={!searchQuery && isSearchPage ? `[&_.sideBar]:hidden` : ""}
      filters={`${DEFAULT_ARTICLE_FILTER}`}
      pagePath="articles"
      preferredResults={preferredResults}
      onCategoryChange={onCategoryChange}
    >
      <Box className={`flex flex-col lg:flex-row`}>
        {!isSearchPage && (
          <Box className="w-full">
            {banner?.title && (
              <Text
                as="h1"
                className="title-tertiary py-2 w-full flex items-center"
              >
                {banner?.title?.text}
              </Text>
            )}

            {banner?.text?.text && (
              <Text
                as="p"
                className="pb-6 text-base text-brandBlack"
              >{RenderHTML(AddFULLAEMURL(banner?.text?.text))}</Text>
            )}
          </Box>
        )}
        {!!searchQuery === isSearchPage && (
          <Box className="w-full">
            <MobileSortable
              isSearchPage={isSearchPage}
              toggleCategory={toggleCategory}
              toggleSort={toggleSort}
              heading={heading}
              selectedCategory={selectedCategory}
            />
          </Box>
        )}
      </Box>

      <Box as="div" className="articleMain">
        <Box as="div">
          {!isSearchPage && <ArticleCategoryList />}
          <Box
            as="div"
            className={`grid ${!searchQuery && isSearchPage ? "grid-cols-1 xs:grid-cols-2  md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4"} gap-6 w-full`}
            ref={gridRef}
          >
            {items.map((item: any) => {
              return (
                <ArticleCard
                  isSearchPage={isSearchPage}
                  data={item}
                  searchQuery={searchQuery}
                  key={item.objectID}
                />
              );
            })}
          </Box>
        </Box>
      </Box>
    </SideBarTemplate>
  );
};

export default ArticleListing;
